import axios from 'axios'
import store from '@/store/index'
import utils from '@/utils/utils'

const electronOriginUrl = window.parent && window.parent.electron && window.parent.electron.electronOriginUrl

const service = axios.create({
  baseURL: electronOriginUrl || '/', // 本地调试 http://192.168.7.184
  timeout: 3000e1
})

service.interceptors.request.use(
  (config) => {
    const {userId, orgId, crmId, projectId, loginType, token} = store.getters.loginObject
    config.headers = {
      v: window.API_VERSION || '355',
      orgId: orgId || 0,
      crmId: crmId || 0,
      userId: userId || 0,
      projectId: projectId || 0,
      token,
      loginType
    }
    const session = {
      token,
      userId,
      projectId,
      loginType
    }
    config.data = {
      ...config.data || {},
      ...session
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    if (res.config.responseType === 'blob') {
      const name = res.headers['content-disposition'].match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1]
      // 匹配正则
      return Promise.resolve({ fileName: decodeURIComponent(name), data: res.data })
      // return Promise.resolve({ fileName: decodeURIComponent(escape(name)), data: res.data });
    }
    const requestCode = res.data.code
    if (requestCode === 0) {
      return Promise.resolve(res.data)
    } else if (requestCode === -502) {
      // token 过期处理
      utils.windowToLogin()
    }
    return Promise.reject(res.data)
  },
  (error) => {
    //  判断请求异常信息中是否含有异常字符串
    if (error.message.includes('ERR_INTERNET_DISCONNECTED')) {
      utils.toNotLinePage()
    } else if (error.message.includes('timeout') || error.message.includes('Error') || error.message.includes('404')) {
      utils.toServerErrorPage()
    } else {
      Promise.reject(error)
    }
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/axios.js